module.exports = __webpack_public_path__ + "38ce21e4839aca4e44b92d8d5a32e2b8.svg";